<template>
  <div
    class="m-banner new"
    v-if="extras.groupKVDisplay && extras.groupKVDisplay.display == 1"
  >
    <div
      class="top"
      v-if="extras.groupNavbarDisplay && extras.groupNavbarDisplay.display == 1"
    ></div>
    <div
      class="banner"
      :style="{
        background:
          extras.bannerWap.colorOrBg == 'color'
            ? extras.bannerWap.color
            : 'url(' + extras.bannerWap.src + ')',
        'background-size': '100% auto',
      }"
    >
      <div class="seminar-info-new wap" :class="extras.BannerTextWap.textAlign">
        <div class="content">
          <div
            class="seminar-title"
            v-if="extras.textSetting.subTitle != 'hide'"
            :style="{
              color:
                extras.textSetting.subTitle == 'custom'
                  ? extras.textSetting.fontColor
                  : '',

              'font-style':
                extras.textSetting.subTitle == 'custom'
                  ? extras.textSetting.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.textSetting.subTitle == 'custom'
                  ? extras.textSetting.fontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
          >
            {{ extras.textSetting.text }}
          </div>
          <div
            class="seminar-slogan"
            v-if="extras.textSetting.title != 'hide'"
            :style="{
              color:
                extras.textSetting.title == 'custom'
                  ? extras.textSetting.fontColor2
                  : '',
              'font-style':
                extras.textSetting.title == 'custom'
                  ? extras.textSetting.fontTilt2 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-size': pxOrVwWap(
                extras.BannerTextSizeWap && extras.BannerTextSizeWap.fontSize
                  ? extras.BannerTextSizeWap.fontSize
                  : 73
              ),
              'font-Weight':
                extras.textSetting.title == 'custom'
                  ? extras.textSetting.fontWeight2 == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
          >
            {{
              extras.textSetting.title == "default"
                ? seminarInfo.title
                : seminarInfo.title
            }}
          </div>
          <div class="semianr-time">
            <div
              class="title"
              v-show="extras.textSetting.timeTitle != 'hide'"
              :style="{
                color:
                  extras.textSetting.timeTitle == 'custom'
                    ? extras.textSetting.fontColor3
                    : '',

                'font-style':
                  extras.textSetting.timeTitle == 'custom'
                    ? extras.textSetting.fontTilt3 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.textSetting.timeTitle == 'custom'
                    ? extras.textSetting.fontWeight3 == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                background: extras.textSetting.bgColor5 || '',
              }"
            >
              {{
                extras.textSetting.timeTitle == "custom"
                  ? extras.textSetting.text3
                  : "会议时间"
              }}
            </div>
            <div
              class="_time"
              v-show="extras.textSetting.time != 'hide'"
              :style="{
                color:
                  extras.textSetting.time == 'custom'
                    ? extras.textSetting.fontColor4
                    : '',

                'font-style':
                  extras.textSetting.time == 'custom'
                    ? extras.textSetting.fontTilt4 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.textSetting.time == 'custom'
                    ? extras.textSetting.fontWeight4 == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                background: extras.textSetting.bgColor6 || '',
              }"
            >
              {{ handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime) }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="seminar-status-bar wap"
        :class="extras.statusBarWap.browse == 'unfixed' ? 'bottom' : ''"
        v-show="extras.groupSignUpDisplay.display == 1"
      >
        <div
          class="status"
          :style="{
            background:
              extras.barBg.colorOrBg == 'color'
                ? extras.barBg.color
                : 'url(' + extras.barBg.src + ')',
          }"
          :class="extras.statusBar.browse"
        >
          <div
            class="dot"
            v-if="extras.countdown.icon != 'hide'"
            :style="{
              'background-color':
                extras.countdown.icon == 'custom' ? extras.countdown.color : '',
            }"
          ></div>
          <span
            :style="{
              color:
                extras.countdown.text == 'custom'
                  ? extras.countdown.customColor
                  : '',
              'font-style':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            v-if="seminarStatus === 3"
            >进行中</span
          >
          <span
            :style="{
              color:
                extras.countdown.text == 'custom'
                  ? extras.countdown.customColor
                  : '',
              'font-style':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras.countdown.text == 'custom'
                  ? extras.countdown.fontWeight == 'on'
                    ? 'bolder'
                    : ''
                  : '',
            }"
            v-if="seminarStatus === 4"
            >已结束</span
          >
          <span v-if="seminarStatus === 1 && extras.countdown.display == 1">
            <span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >距离会议开始</span
            >
            <span
              class="seminar-remainder-num"
              :style="{
                color:
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeCustomColor
                    : '',
                'font-style':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ remainder.days }}</span
            >
            <span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >天</span
            >
            <span
              class="seminar-remainder-num"
              :style="{
                color:
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeCustomColor
                    : '',
                'font-style':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ remainder.hours }}</span
            >
            <span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >时</span
            >
            <span
              class="seminar-remainder-num"
              :style="{
                color:
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeCustomColor
                    : '',
                'font-style':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.time == 'custom'
                    ? extras.countdown.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >{{ remainder.minutes }}</span
            >
            <span
              :style="{
                color:
                  extras.countdown.text == 'custom'
                    ? extras.countdown.customColor
                    : '',
                'font-style':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.countdown.text == 'custom'
                    ? extras.countdown.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
              >分</span
            >
          </span>
        </div>
        <div
          class="seminar-btn"
          v-if="
            !isFrozen &&
            seminarStatus !== 4 &&
            extras.signUpSetting.display == 1
          "
          :style="{
            background:
              extras.signUpSetting.layout == 'custom'
                ? extras.signUpSetting.colorOrBg == 'color'
                  ? extras.signUpSetting.color
                  : 'url(' + extras.signUpSetting.src + ')'
                : '',
          }"
        >
          <div
            class="btn"
            :class="isSetting == 1 ? 'cursor-default' : ''"
            v-show="isSetting == 1"
            :style="{
              background:
                extras.signUpSetting.layout == 'custom'
                  ? extras.signUpSetting.colorOrBg == 'color'
                    ? extras.signUpSetting.color
                    : 'url(' + extras.signUpSetting.src + ')'
                  : '',
            }"
          >
            {{ extras.signUpText.model || "立即报名" }}
          </div>
          <div
            class="btn"
            v-show="
              isSetting !== 1 &&
              memberInfo.signUpStatus == 0 &&
              !isLogin &&
              seminarInfo.isOpenMember != 0 &&
              signUpUrl
            "
            :style="{
              background:
                extras.signUpSetting.layout == 'custom'
                  ? extras.signUpSetting.colorOrBg == 'color'
                    ? extras.signUpSetting.color
                    : 'url(' + extras.signUpSetting.src + ')'
                  : '',
            }"
            @click="goto('newLogin')"
          >
            {{ extras.signUpText.model || "立即报名" }}
          </div>
          <div
            v-if="
              isSetting !== 1 &&
              memberInfo.signUpStatus == 0 &&
              (isLogin || seminarInfo.isOpenMember == 0) &&
              signUpUrl
            "
            class="btn"
            :style="{
              background:
                extras.signUpSetting.layout == 'custom'
                  ? extras.signUpSetting.colorOrBg == 'color'
                    ? extras.signUpSetting.color
                    : 'url(' + extras.signUpSetting.src + ')'
                  : '',
            }"
            @click="goto('signUp')"
          >
            {{ extras.signUpText.model || "立即报名" }}
          </div>
          <div
            v-if="isSetting !== 1 && memberInfo.signUpStatus == 1"
            :style="{
              background:
                extras.signUpSetting.layout == 'custom'
                  ? extras.signUpSetting.colorOrBg == 'color'
                    ? extras.signUpSetting.color
                    : 'url(' + extras.signUpSetting.src + ')'
                  : '',
            }"
            class="btn audit"
            @click="goto('signUp')"
          >
            {{ extras.checkText.model || "审核中..." }}
          </div>
          <div
            v-if="
              isSetting !== 1 &&
              (memberInfo.signUpStatus == 2 || memberInfo.signUpStatus == 3)
            "
            :style="{
              background:
                extras.signUpSetting.layout == 'custom'
                  ? extras.signUpSetting.colorOrBg == 'color'
                    ? extras.signUpSetting.color
                    : 'url(' + extras.signUpSetting.src + ')'
                  : '',
            }"
            class="btn registered"
            @click="goto('signUp')"
          >
            {{ extras.checkedText.model || "报名成功" }}
          </div>
          <div
            v-if="isSetting !== 1 && memberInfo.signUpStatus == 4"
            :style="{
              background:
                extras.signUpSetting.layout == 'custom'
                  ? extras.signUpSetting.colorOrBg == 'color'
                    ? extras.signUpSetting.color
                    : 'url(' + extras.signUpSetting.src + ')'
                  : '',
            }"
            class="btn refuse"
            @click="goto('signUp')"
          >
            {{ extras.rejectText.model || "拒绝报名" }}
          </div>
          <div v-if="seminarStatus === 2" class="btn registered">
            会议已结束
          </div>
        </div>
      </div>
    </div>

    <div class="frame-outer-wap" v-if="showFrame">
      <div class="sign-frame" :style="{ top: top }">
        <span class="icontemp stemp-close" @click="close()"></span>
        <iframe frameborder="0" :src="url"></iframe>
        <div class="sk-loading sk-loading2">
          <div class="sk-loading-wrap">
            <div class="sk-loading-row">
              <div class="sk-loading-spin">
                <span class="sk-loading-item"></span
                ><span class="sk-loading-item"></span
                ><span class="sk-loading-item"></span
                ><span class="sk-loading-item"></span>
              </div>
            </div>
            <div class="sk-loading-text">Loading...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, URLS } from "fire-wind-water";
import moment from "moment";
import { handleTimeStampToDateTime } from "@/utils/utils";
import Api from "@/service/api";
import { goto } from "../../mixins/goto";

export default {
  name: "Banner",
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    signUpStatus: Number,
    loginUrl: String,
    registerUrl: String,
    isFrozen: Boolean,

    extras: {
      banner: {
        src: "",
      },
      backgroundColor: {
        value: "#135ed8",
      },
    },
  },
  data: function () {
    return {
      isLogin: false,
      signUpUrl: "",
      isSetting: 0,
      showFrame: false,
      top: "",
      seminarStatus: 0, //0 未开始 1 已经开始 2 已经结束
      imgUrlObj: {
        wap: {
          banner: require("@/assets/images/banner.jpg"),
        },
      },
      remainder: { days: 0, hours: 0, minutes: 0 },
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  watch: {
    memberInfo() {
      if (URLS.getURL("openSign")) {
        if (
          this.memberInfo.signUpStatus == 0 &&
          (this.isLogin || this.seminarInfo.isOpenMember == 0) &&
          this.signUpUrl
        ) {
          this.goto("signUp");
        }
      }
    },
  },
  mounted() {
    $subscriber.subscribe("wap-goSign", () => {
      this.goto("signUp");
    });

    console.log("banner2-extras", this.extras);

    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    let signUpUrl = this.seminarInfo.signUp;
    const tc = URLS.getURL("tc");
    if (tc) {
      signUpUrl = `${signUpUrl}&tc=${tc}`;
    }
    this.signUpUrl = signUpUrl;
    // if (smarket.urlParams.tc != null) {
    //   signUpUrl = signUpUrl + "&tc=" + smarket.urlParams.tc;
    // }
    if (this.seminarInfo && this.seminarInfo.startTime) {
      Api.getServerTime().subscribe((res) => {
        let startTime = this.seminarInfo.startTime * 1000;
        let endTime = this.seminarInfo.endTime * 1000;
        let currentTime = res.content * 1000;
        let diffTime = endTime;
        this.seminarStatus = 3;
        if (currentTime < startTime) {
          this.seminarStatus = 1;
          diffTime = startTime;
        } else if (currentTime > endTime) {
          this.seminarStatus = 4;
          return;
        }
        let dif = moment(diffTime).diff(res.content * 1000, "minutes");
        let days = Math.floor(dif / (24 * 60));
        let hours = Math.floor(dif / 60) - days * 24;
        let minutes = dif % 60;
        this.remainder = {
          days,
          hours,
          minutes,
        };
      });
    } else {
      this.remainder = "会议准备中";
    }
  },
  methods: {
    close() {
      $subscriber.emit("reload-userInfo");
      this.top = "100vh";
      document.body.style.setProperty("overflow", "auto");
      setTimeout(() => {
        this.showFrame = false;
      }, 400);
    },
    goto(s) {
      let url = "";
      switch (s) {
        case "newLogin":
          url = goto.newLogin(
            URLS.updateSearchParam("openSign", "1", window.location.href),
            true
          );
          window.$sk.goto(url);
          break;
        case "login":
          // goto.loginToSignUp();
          url = goto.login(
            URLS.updateSearchParam("openSign", "1", window.location.href),
            true
          );
          window.$sk.goto(url);
          break;
        case "signUp":
          //         this.url = goto.signUp(true);
          url = goto.signUp(true);
          this.url = URLS.updateSearchParam("puzzleFlag", "", url); //iframe内嵌模式 不能授权 去掉puzzle
          // this.url = 'http://uat-local.smarket.net.cn:8081/?customFormId=2308101668095181&instanceId=716348&linkId=364662&configId=1992809&preview=1#/wapNew_index?randNum=1694887270';
          this.showFrame = true;
          document.body.style.setProperty("overflow", "hidden");
          setTimeout(() => {
            this.top = "20vh";
          }, 100);
          break;
      }
    },
    gotoUrl: (url) => {
      const markCode = URLS.getURL("markCode");
      const markType = URLS.getURL("markType");
      let u = markCode
        ? URLS.updateSearchParam("markCode", markCode, url)
        : url;
      u = markType ? URLS.updateSearchParam("markType", markType, u) : u;
      window.$sk.goto(u);
    },
    handleDiffTimeForNow: (seminarInfo) => {
      if (seminarInfo && seminarInfo.startTime) {
        let startTime = seminarInfo.startTime * 1000;
        let endTime = seminarInfo.endTime * 1000;
        let currentTime = moment().unix() * 1000;
        let seminarStatus = "结束";
        let diffTime = endTime;
        if (currentTime < startTime) {
          seminarStatus = "开始";
          diffTime = startTime;
        } else if (currentTime > endTime) {
          this.seminarStatus = 4;
          return "会议已经结束";
        }
        let dif = moment(diffTime).diff(moment(), "minutes");
        let days = Math.floor(dif / (24 * 60));
        let hours = Math.floor(dif / 60) - days * 24;
        let minutes = dif % 60;
        return `距离大会${seminarStatus}还有<span class="seminar-remainder-num">${days}</span>天<span class="seminar-remainder-num">${hours}</span>小时<span class="seminar-remainder-num">${minutes}</span>分`;
      }
      return "会议准备中";
    },
    handleTimeStamps: (startTimeStamp, endTimeStamp) => {
      let startTimeYear = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY");
      let startDate = handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日 HH:mm"
          ) +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "MM月DD日")
        );
      } else {
        return (
          handleTimeStampToDateTime(startTimeStamp * 1000, "YYYY年MM月DD日") +
          "~" +
          handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY年MM月DD日")
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sk-loading2 {
  position: absolute;
  z-index: -1;
  border-radius: 5.3333333333vw 5.3333333333vw 0px 0px;
}
</style>
